<template>
  <el-card class="main-card">
    <template #header>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/purchase/brand' }">品牌管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ isEdit ? '编辑品牌' : '新增品牌' }}</el-breadcrumb-item>
      </el-breadcrumb>
    </template>

    <el-form :model="forms" :rules="rules" ref="forms" label-width="120px" class="detail-form">
      <el-tabs v-model="activeTab" type="border-card">
        <el-tab-pane label="基本信息" name="basic">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item label="品牌编号" prop="brandCode">
                <el-input v-model="forms.brandCode" autocomplete="off" placeholder="需唯一的编号" :disabled="isEdit"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item label="品牌名称" prop="brandName">
                <el-input v-model="forms.brandName" autocomplete="off" :disabled="isView"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item label="品牌类型" prop="brandType">
                <el-select v-model="forms.brandType" placeholder="请选择" :disabled="isView">
                  <el-option label="自有" value="自有"></el-option>
                  <el-option label="代理" value="代理"></el-option>
                  <el-option label="授权" value="授权"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item label="开始时间" prop="startDate">
                <el-date-picker v-model="forms.startDate" type="date" placeholder="选择日期" :disabled="isView" style="width:100%"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item label="结束时间" prop="endDate">
                <el-date-picker v-model="forms.endDate" type="date" placeholder="选择日期" :disabled="isView" style="width:100%"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item label="联系人" prop="contactName">
                <el-input v-model="forms.contactName" autocomplete="off" :disabled="isView"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item label="联系电话" prop="contactPhone">
                <el-input v-model="forms.contactPhone" autocomplete="off" :disabled="isView"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item label="联系邮箱" prop="contactEmail">
                <el-input v-model="forms.contactEmail" autocomplete="off" type="email" :disabled="isView"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <el-form-item label="联系地址" prop="contactAddress">
                <el-input v-model="forms.contactAddress" autocomplete="off" type="textarea" :rows="2" :disabled="isView"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12">
              <el-form-item label="官网" prop="website">
                <el-input v-model="forms.website" autocomplete="off" :disabled="isView"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item label="状态" prop="status">
                <el-radio-group v-model="forms.status" :disabled="isView">
                  <el-radio :label="1">启用</el-radio>
                  <el-radio :label="0">停用</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </el-tab-pane>

        <el-tab-pane label="系统信息" name="system" v-if="isEdit">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item label="创建人">
                <el-input v-model="forms.createUserName" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item label="创建时间">
                <el-input :value="$util.fmtDate(forms.createDate, 'yyyy-MM-dd HH:mm:ss')" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item label="更新人">
                <el-input v-model="forms.updateUserName" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
              <el-form-item label="更新时间">
                <el-input :value="$util.fmtDate(forms.updateDate, 'yyyy-MM-dd HH:mm:ss')" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>

      <div class="form-actions">
        <el-button type="primary" icon="Select" @click="submit" v-if="!isView">保存</el-button>
        <el-button icon="Back" @click="goBack">返回</el-button>
      </div>
    </el-form>
  </el-card>
</template>

<script>
export default {
  name: 'PurchaseBrandDetail',
  data() {
    return {
      forms: {
        status: 1
      },
      rules: {
        brandCode: [ { required: true, message: '请输入品牌编号', trigger: 'blur' }, { min:1, max:80, message: '最大长度80', trigger: 'blur' } ],
        brandName: [ { required: true, message: '请输入品牌名称', trigger: 'blur' }, { min:1, max:200, message: '最大长度200', trigger: 'blur' } ],
        contactPhone: [ { pattern: /^1[3-9]\d{9}$|^0\d{2,3}-?\d{7,8}$/, message: '请输入正确的联系电话', trigger: 'blur' } ],
        contactEmail: [ { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' } ]
      },
      activeTab: 'basic'
    };
  },
  computed: {
    isEdit() { return this.$route.query.id && this.$route.query.mode !== 'view'; },
    isView() { return this.$route.query.mode === 'view'; },
    brandId() { return this.$route.query.id; }
  },
  mounted() {
    if (this.brandId) this.loadBrand();
  },
  methods: {
    loadBrand() {
      let api = this.$kaung.init('PurchaseBrand');
      api.getone(this.brandId).then((res) => {
        if (res.code === 200) this.forms = { ...res.data };
      });
    },
    submit() {
      this.$refs.forms.validate((valid) => {
        if (!valid) return;
        let api = this.$kaung.init('PurchaseBrand');
        api.submit({ id: this.forms.id, data: this.forms }).then((res) => {
          if (res.code === 200) {
            this.$message({ type: 'success', message: res.content });
            this.goBack();
          }
        });
      });
    },
    goBack() { this.$router.push({ name: 'PurchaseBrand' }); }
  }
};
</script>

<style scoped>
.detail-form { padding: 20px; }
.form-actions { text-align: center; margin-top: 30px; padding: 20px 0; border-top: 1px solid #e4e7ed; }
.form-actions .el-button { margin: 0 10px; min-width: 100px; }
.el-tabs__content { padding: 20px 0; }
</style>
